// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playtests .playtest-interest{margin-bottom:48px}.playtests .remote-testing .btn-yes-no{margin-bottom:0}.playtests .studio-testing .btn-yes-no{margin-bottom:0}.playtests .mobile-testing .btn-yes-no{margin-bottom:0}.playtests .tools-software .btn-yes-no{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
